import { Link } from "react-router-dom";

import { useEffect } from "react";
import { Helmet } from "react-helmet";

function CareerDetail() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>Career Detail </title>

      </Helmet>
        <div class="fancy-hero-five " style={{ 'padding': " 65px 0" }}>

          <div class="bg-wrapper">
            <div class="container">
              <div class="row">
                <div class="col-lg-7 m-auto text-center">

                  <h6><span class="upper-title custom-name text-uppercase">Join the team</span></h6>
                  <h3 class="maintitle mb-4 mt-2">Explore ideas, tips</h3>
                  <p className="mainp">We are seeking a talented and creative Content Writer to join our team. As a Content Writer, you will play a crucial role in developing high-quality</p>

                  <a class="theme-btn-2 mt-10 md-mt-30 text-uppercase" href="/demo-request">Apply today <i class="bi bi-arrow-right pl-2"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="feature-blog-one blogs bg-white">
          <div class="shapes shape-one"></div>
          <div class="shapes shape-two"></div>
          <div class="shapes shape-three"></div>
          <div class="container  bloginner">


            <div class="row">
              <div class="col-lg-12">
                <div class="Solutions-box w-100 border-right">
                  <div className="row">
                    <div className="col-md-4"><div className="department-box py-3 w-100 text-center"><h4 className="mb-2 text-primary">Marketing</h4> <h6><span class="upper-title custom-name text-uppercase">Departmentm</span></h6></div></div>
                    <div className="col-md-4"><div className="department-box py-3 w-100 text-center"><h4 className="mb-2 text-primary">Full Time</h4> <h6><span class="upper-title custom-name text-uppercase">Job Type</span></h6></div></div>
                    <div className="col-md-4"><div className="department-box py-3 w-100 text-center"><h4 className="mb-2 text-primary">Noida</h4> <h6><span class="upper-title custom-name text-uppercase">Location</span></h6></div></div>
                  </div>
                </div>
              </div>

            </div></div>
        </div>
        <div class="block-style-thirtySix bg-white border-bottom blogs lg-container pt-160  pb-80" id="feature">
          <div class="container">
            <div class="row">
              <div class=" col-lg-12  " >
                <div class="text-wrapper">
                  <p className="mainp">TaskFlier emerges as the premier management system developed by MNB Soft Solutions. Thanks to the folks at TaskFlier, the operational concerns that plague today’s businesses are well understood and thus we embark on a trip to ease processes, enhance productivity, and improve inter-relationships, among many other things.</p>

                  <h4 className="position"> </h4>
                  <ul class="bullet">
                    <li>Manage software development, testing, and deployment projects.</li>
                    <li>Track sprint cycles and ensure timely releases.</li>
                  </ul>
                  <h4>Marketing Agencies</h4>
                  <ul class="bullet">
                    <li>Plan, execute, and analyze campaign performance.</li>
                    <li>Coordinate content creation and social media strategies.</li>
                  </ul>
                  <h4>Construction &amp; Engineering Firms</h4>

                </div>

              </div>


            </div>
          </div>
        </div>



        <div class="fancy-feature-thirtyFour pt-80 pb-100 bg-gray">
          <div class="container">
            <div class="title-style-two text-center mb-40 md-mb-40">

              <h6><span class="upper-title custom-name mb-10">Get going with Taskflier </span></h6>
              <h3 class="maintitle "><span>Why Work With Us?</span></h3>

            </div>

            <div class="row  features">


              <div class="col-lg-4 col-12 ">

                <div class="Solutions-box " >
                  <img src="/main/images/task-creation.png" alt="Task creation" class="w-100" />
                  <h6 className="mt-1"><span class="upper-title custom-name">Inclusive Culture </span></h6>
                  <div class="pack-name mt-2 text-capitalize">Empowerment Through Diversity: Thriving Together in Unity</div>
                  <hr></hr>
                  <p className="mainp">We imbibe a culture that celebrates diversity and encourages individuality. At TaskFlier, everyone’s voice is heard, and each employee plays a vital role in our success.</p>


                </div>

              </div>
              <div class="col-lg-4 col-12 ">

                <div class="Solutions-box " >
                  <h6 className="mt-1"><span class="upper-title custom-name">Collaborative Environment</span></h6>
                  <div class="pack-name mt-2 text-capitalize">Shared Vision: Driving Innovation with Collaborative Team Dynamics
                  </div>
                  <hr></hr>
                  <p className="mainp">Our team-oriented approach promotes collaboration across all levels of the organization. You will have the opportunity to work with talented professionals from diverse backgrounds and expertise</p>
                  <img src="/main/images/customizing-taskboard.png" alt="Customizing taskboard" class="w-100" />
                </div>

              </div>
              <div class="col-lg-4 col-12 ">

                <div class="Solutions-box " >
                  <img src="/main/images/task-dependencies.png" alt="Task dependencies" class="w-100" />
                  <h6 className="mt-1"><span class="upper-title custom-name">Work-Life Balance </span></h6>
                  <div class="pack-name mt-2 text-capitalize">Achieving Harmony Between ‍Work and Home Life</div>
                  <hr></hr>
                  <p className="mainp">We understand the importance of balancing professional and personal life. We offer flexible working hours, remote work options, and comprehensive wellness programs to support our employees' well-being.</p>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="fancy-feature-fortySix lg-container mega-feature pt-100 pt-100 pb-150 md-pt-80 lg-pb-80" id="feature">
          <div class="container">
            <div class="title-style-two text-center mb-40 md-mb-40">
              <h2>
                <span>
                  Why Join Us?

                </span>
              </h2>
              <div class="sub-text mt-15 maxsubtitle">
                Joining our team offers a wealth of opportunities for both personal <br></br> and professional growth
              </div>
            </div>
            <div class="title-style-twelve">

              <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6 d-flex aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200">
                  <div class="block-style-five">
                    <div class="icon"><img src="images/icon/20.svg" alt="" /></div>
                    <h6 class="title"><span>Employee Centric Facilities</span></h6>
                    <p>Our facilities prioritize comfort and collaboration, featuring modern amenities that enhance productivity, foster innovation, and support your professional growth.</p>
                  </div>

                </div>
                <div class="col-lg-4 col-md-6 d-flex aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                  <div class="block-style-five">
                    <div class="icon"><img src="images/icon/21.svg" alt="" /></div>
                    <h6 class="title"><span>Reward & Recognition</span></h6>
                    <p>We offer competitive rewards and recognition programs to celebrate achievements and exceptional contributions to our success.</p>
                  </div>

                </div>
                <div class="col-lg-4 col-md-6 d-flex aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                  <div class="block-style-five">
                    <div class="icon"><img src="images/icon/22.svg" alt="" /></div>
                    <h6 class="title"><span>Career growth</span></h6>
                    <p>We provide robust development opportunities, nurturing potential and ensuring every team member has the tools to succeed and advance in their career.</p>
                  </div>

                </div>

                <div class="col-lg-4 col-md-6 d-flex aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200">
                  <div class="block-style-five">
                    <div class="icon"><img src="images/icon/20.svg" alt="" /></div>
                    <h6 class="title"><span>Health and Wellness</span></h6>
                    <p>Comprehensive health insurance plans, including medical, dental, and vision coverage. Access to wellness programs, and fitness incentives.</p>
                  </div>

                </div>
                <div class="col-lg-4 col-md-6 d-flex aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                  <div class="block-style-five">
                    <div class="icon"><img src="images/icon/21.svg" alt="" /></div>
                    <h6 class="title"><span>Great culture</span></h6>
                    <p>Experience a supportive and inclusive work environment that fosters collaboration, innovation, and mutual respect among all team members.</p>
                  </div>

                </div>
                <div class="col-lg-4 col-md-6 d-flex aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                  <div class="block-style-five">
                    <div class="icon"><img src="images/icon/22.svg" alt="" /></div>
                    <h6 class="title"><span>Flexible Work Arrangements</span></h6>
                    <p>Benefit from flexible hours and remote work options, allowing you to tailor your schedule for a balanced work-life harmony.</p>
                  </div>

                </div>
              </div>







            </div>

          </div>
        </div>
    </>
  );
}

export default CareerDetail;